import type { TFunction } from "i18next";

const extractMessageFromApi = (
  // eslint-disable-next-line
  value: any,
  t: TFunction<"translation", undefined>,
): Error => {
  const message =
    value?.response?.data?.message ??
    value?.data?.message ??
    value?.response?.message ??
    value?.message;

  if (message) {
    const parts = message.split("#");

    if (parts.length === 3) {
      switch (parts[0]) {
        case "ERROR": {
          const message = t(`apiError.${parts[1]}`);

          if (message) {
            return new Error(message);
          }

          return new Error(parts[2]);
        }
        case "SUCCESS": {
          const message = t(`apiSuccess.${parts[1]}`);

          if (message) {
            return new Error(message);
          }

          return new Error(parts[2]);
        }
      }
    }
  }

  return value;
};

export { extractMessageFromApi };
